import { render } from "./SinisterDetails.vue?vue&type=template&id=ed77dc64&scoped=true"
import script from "./SinisterDetails.vue?vue&type=script&lang=js"
export * from "./SinisterDetails.vue?vue&type=script&lang=js"

import "./SinisterDetails.vue?vue&type=style&index=0&id=ed77dc64&scoped=true&lang=css"

import exportComponent from "/var/www/extranet-sinistre/production/client/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ed77dc64"]])

export default __exports__